import { Component } from "@angular/core";
import { NavButton } from "../../shared/components/navigation/next-button.component";
import { AppFlowService } from "../../shared/services/app-flow/app-flow.service";
import { clientConfig } from "../../shared/constant/app.constant";

@Component({
  selector: "app-add-item",
  templateUrl: "./add-item.component.html",
})
export class MAddItemComponent {
  brandInfo: BrandingInfo = {
    logoSrc: clientConfig.LOGO_URL, //this.getSampleBase64Image(),
  };
  nextButton: NavButton = {
    buttonText: "Continue",
    cssClass: "next-btn",
    isDisable: true,
  };
  screenNav: NavButton = {
    buttonText: "Add return items",
    cssClass: "my-class",
    number: 1,
    // routeUrl: "/d/main",
  };

  constructor(private appFlowService: AppFlowService) {
    const route = this.appFlowService.findRouteFromSequence("additems");
    this.nextButton.routeUrl = `/m/${route.next}`;
    this.screenNav.routeUrl = `/m/${route.back}`;
    this.nextButton.isDisable = true;
  }
}
